import type { Formatter } from "react-timeago";

export const timeAgoFormatter: Formatter = (
  value,
  unit,
  suffix,
  epochMilliseconds,
  nextFormatter,
) =>
  unit === "second"
    ? "Just now"
    : nextFormatter == null
      ? undefined
      : nextFormatter(value, unit, suffix, epochMilliseconds);
